<template>
  <div
    class="main-layout__item main-layout__item_head main-layout__item_hover main-layout__item_p12"
  >
    <div class="w-3 t-c foz-23">#</div>
    <div class="w-4 main-layout__item-image">
      <!-- Service -->
      <!-- <div class="main-layout__sort-box">
        <sort-svg @onClick="sort('service', 'asc')" class="sort-svg sort-svg_up" ref="service_asc" />

        <sort-svg @onClick="sort('service', 'desc')" class="sort-svg" ref="service_desc" />
      </div>-->
    </div>
    <div class="w-7">{{ $t("listsHeader.createdAt") }}</div>
    <div class="w-4">{{ $t("forms.source") }}</div>
    <div class="w-6">
      MyHammer
    </div>
    <div class="w-6">
      Tag
    </div>
    <div class="w-7">{{ $t("listsHeader.full_name") }}</div>
    <div class="w-5 main-flex">
      {{ $t("listsHeader.price") }}
      <div class="main-layout__sort-box">
        <sort-svg
          @onClick="sort('price', 'asc')"
          ref="price_asc"
          class="sort-svg sort-svg_up"
        />

        <sort-svg
          @onClick="sort('price', 'desc')"
          ref="price_desc"
          class="sort-svg"
        />
      </div>
    </div>
    <div class="w-10 main-flex">
      {{ $t("listsHeader.email") }}
      <div class="main-layout__sort-box">
        <sort-svg
          @onClick="sort('email', 'asc')"
          ref="email_asc"
          class="sort-svg sort-svg_up"
        />

        <sort-svg
          @onClick="sort('email', 'desc')"
          ref="email_desc"
          class="sort-svg"
        />
      </div>
    </div>
    <div class="w-7">{{ $t("listsHeader.phone") }}</div>
    <div class="w-5 main-flex">
      {{ $t("listsHeader.paid") }}
      <div class="main-layout__sort-box">
        <sort-svg
          @onClick="sort('isPaid', 'asc')"
          ref="isPaid_asc"
          class="sort-svg sort-svg_up"
        />

        <sort-svg
          @onClick="sort('isPaid', 'desc')"
          ref="isPaid_desc"
          class="sort-svg"
        />
      </div>
    </div>
    <div class="w-8 main-flex">
      {{ $t("ordersStatus.payment") }}
      <div class="main-layout__sort-box">
        <sort-svg
          @onClick="sort('paymentType', 'asc')"
          ref="paymentType_asc"
          class="sort-svg sort-svg_up"
        />

        <sort-svg
          @onClick="sort('paymentType', 'desc')"
          ref="paymentType_desc"
          class="sort-svg"
        />
      </div>
    </div>
    <div class="w-5">{{ $t("listsHeader.estimate") }}</div>
    <div class="w-5">{{ $t("listsHeader.spent") }}</div>

    <!-- <div class="w-5 main-flex">
      {{ $t("forms.company") }}
      <div class="main-layout__sort-box">
        <sort-svg
          @onClick="sort('companyRating', 'asc')"
          ref="companyRating_asc"
          class="sort-svg sort-svg_up"
        />

        <sort-svg
          @onClick="sort('companyRating', 'desc')"
          ref="companyRating_desc"
          class="sort-svg"
        />
      </div>
    </div>
    <div class="w-5 main-flex">
      {{ $t("forms.master") }}
      <div class="main-layout__sort-box">
        <sort-svg
          @onClick="sort('masterRating', 'asc')"
          ref="masterRating_asc"
          class="sort-svg sort-svg_up"
        />

        <sort-svg
          @onClick="sort('masterRating', 'desc')"
          ref="masterRating_desc"
          class="sort-svg"
        />
      </div>
    </div> -->

    <div class="w-6 main-flex">
      {{ $t("listsHeader.should_start") }}
      <div class="main-layout__sort-box">
        <sort-svg
          @onClick="sort('shouldStartedAt', 'asc')"
          ref="shouldStartedAt_asc"
          class="sort-svg sort-svg_up"
        />

        <sort-svg
          @onClick="sort('shouldStartedAt', 'desc')"
          ref="shouldStartedAt_desc"
          class="sort-svg"
        />
      </div>
    </div>

    <div class="w-7 pl-5 main-flex">
      {{ $t("listsHeader.status") }}
      <div class="main-layout__sort-box">
        <sort-svg
          @onClick="sort('status', 'asc')"
          ref="status_asc"
          class="sort-svg sort-svg_up"
        />

        <sort-svg
          @onClick="sort('status', 'desc')"
          ref="status_desc"
          class="sort-svg"
        />
      </div>
    </div>
    <div class="w-5">{{ $t("listsHeader.actions") }}</div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import sort from '@/mixins/sort'
import sortSvg from '@/components/controls/sortSvg'

export default {
    mixins: [sort],
    components: {
        sortSvg,
    },
    methods: {
        ...mapMutations({
            setSort: 'orders/setSort',
        }),
        ...mapActions({
            fetch: 'orders/fetch',
        }),
        sort(orderBy, sortBy) {
            const isChanged = this.markSvgsComponents(`${orderBy}_${sortBy}`)

            this.setSort({
                sortBy: isChanged ? `&sortedBy=${sortBy}` : '',
                orderBy: isChanged ? `&orderBy=${orderBy}` : '',
            })
            this.fetch({ isFilter: true, page: 1 })
        },
    },
}
</script>
